import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'what_is_the_facs_definition_of_lead_time'

export const dataPointDefinition = {
  retracedId: 'what_is_the_facs_definition_of_lead_time',
  name: "What is the facility's definition of lead time?",
  description:
    'Please describe in narrative form what your definition of lead time is. The actual number associated with your lead time is entered in the next question. This question focuses on an explanation of what your facility considers as lead time. Usually, lead time is the amount of time a process takes from start to finish in the facility. To answer this question you should provide details around the processes that involve your start and finish. ',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-pi-19',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 3880,
  sectionId: '1.3',
  impactArea: 'Operational Metrics',
  impactAreaId: 'OPERATIONAL_METRICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
